export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В процесі"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завершено"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Очікування"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Наступний"])}
}